import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { query } from '../../common/requests/base.query.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const GET_LAST_COMPLETED_STEP_QUERY = query({
  getLastCompletedStep: [
    { input: input('input', 'GetLastCompletedStepInput!') },
    {
      lesson: true,
      task: true,
      step: true,
      completedAt: true,
    },
  ],
});

type GetLastCompletedStepInputType = VariablesOf<typeof GET_LAST_COMPLETED_STEP_QUERY>['input'];
type GetLastCompletedStepResponseType = ResultOf<typeof GET_LAST_COMPLETED_STEP_QUERY>['getLastCompletedStep'];

export const getLastCompletedStepQueryRequest = async (
  props: GetLastCompletedStepInputType
): Promise<ResultType<GetLastCompletedStepResponseType>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.query(GET_LAST_COMPLETED_STEP_QUERY, { input: props }, ['progress'], { useAuth: true });

  return {
    success: Boolean(response?.getLastCompletedStep),
    data: response?.getLastCompletedStep ?? { completedAt: null },
  };
};
